import { LISRISCode } from "@/Common/Models/LISRISCode";

class LabRequest {
    public Id: string;
    public Request: string;
    public IsPrinted: boolean;
    public DatePrinted: Date;
    public RequestDate: Date;
    public EncounterId: string;
    public RequestingStaffContactFacetId: string;
    public Type: LabRequestType;
    public DueDate: Date;
    public Reason: string;
    public IsSupervisorRequired: boolean;
    public PriorityDropdownId: string;
}

class LabRequestBillCode {
    public cId: number;
    public Number: string;
    public CostCenterId: string;
    public Price: number;
    public QST: number;
    public GST: number;
    public HadQST: number;
    public HadGST: number;
    public LabRequestId: string;
    public TransfertDate: Date;

    public static fromLisRisCode(code: LISRISCode): LabRequestBillCode {
        const bill = new LabRequestBillCode();
        bill.Price = isNaN(parseFloat(code.Price)) ? null : parseFloat(code.Price);
        bill.Number = code.Code;
        bill.CostCenterId = code.CostCenterId;
        return bill;
    }
}

enum LabRequestType {
    None = 0,
    RIS = 1, // Christus Interface Radio
    LIS = 2 // Christus Interface Lab
}

enum LabRequestFormMode {
    Viewing = 0,
    Creating = 1,
    Editable = 2
}

export { LabRequest, LabRequestBillCode, LabRequestFormMode, LabRequestType };
